import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d31a69a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-4 flex justify-content-center font-bold",
  style: {"font-size":"14px"}
}, "1ra", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-4 flex justify-content-center font-bold",
  style: {"font-size":"14px"}
}, "2da", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-4 flex justify-content-center font-bold",
  style: {"font-size":"14px"}
}, "3da", -1))
const _hoisted_5 = { class: "col-4 flex justify-content-center" }
const _hoisted_6 = { class: "m-auto font-bold" }
const _hoisted_7 = { class: "col-4 flex justify-content-center" }
const _hoisted_8 = { class: "m-auto font-bold" }
const _hoisted_9 = { class: "col-4 flex justify-content-center" }
const _hoisted_10 = { class: "m-auto font-bold" }

import { Result } from "@/interfaces/Result";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RdBolos',
  props: {
    result: {},
    isToday: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const bolo1 = computed(() => (props.result.numbers.length > 0 ? props.result.numbers[0] : null));
const bolo2 = computed(() => (props.result.numbers.length > 1 ? props.result.numbers[1] : null));
const bolo3 = computed(() => (props.result.numbers.length > 2 ? props.result.numbers[2] : null));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass(["border-circle bolo mt-0 mb-1 mx-1 flex", { 'bg-green-500': bolo1.value !== null && _ctx.isToday, 'bg-red-500 text-white': bolo1.value !== null && !_ctx.isToday, 'surface-500': bolo1.value === null }])
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(bolo1.value), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["border-circle bolo mt-0 mb-1 mx-1 flex", { 'bg-green-500': bolo2.value !== null && _ctx.isToday, 'bg-red-500 text-white': bolo2.value !== null && !_ctx.isToday, 'surface-500': bolo2.value === null }])
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(bolo2.value), 1)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: _normalizeClass(["border-circle bolo mt-0 mb-1 mx-1 flex", { 'bg-green-500': bolo3.value !== null && _ctx.isToday, 'bg-red-500 text-white': bolo3.value !== null && !_ctx.isToday, 'surface-500': bolo3.value === null }])
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(bolo3.value), 1)
      ], 2)
    ])
  ]))
}
}

})